import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { PosCashier } from '../../../models/pos.model';
import { StorageCenter } from '../../../models/storage.center.model';
import { TreasuryAccount } from '../../../models/treasury.account.model';
import { Company } from '../../../models/company.model';
import { Variant } from '../../../models/variant.model';
import { AccountingEntry } from '../../../models/accounting.entry.model';
import { AppService } from '../../../models/app.service.model';

export interface PosPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  cashiersForCompany: PosCashier[] | null,
  accountingCreditEntriesForCompany: AccountingEntry[] | null,
  setCashiersForCompany: Dispatch<SetStateAction<PosCashier[] | null>>,
  loadCashiersForCompany: Function,
  storageCentersForCompany: StorageCenter[] | null,
  loadStorageCentersForCompany: Function,
  userLoggedIn: any,
  contactsForCompany: any,
  productsForCompany: any,
  productVariantsForCompany: Variant[] | null,
  servicesForCompany: any,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  loadContactsForCompany: Function,
  settingsForCompany: any,
  loadProductproductVariantsForCompany: Function,
  loadSettingsForCompany: Function
};

const PosPage: React.FunctionComponent<PosPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, userLoggedIn, contactsForCompany,accountingCreditEntriesForCompany, productsForCompany, productVariantsForCompany, servicesForCompany, storageCentersForCompany, treasuryAccountsForCompany, loadContactsForCompany, settingsForCompany, loadSettingsForCompany, loadStorageCentersForCompany, loadProductproductVariantsForCompany} = UseOutletContext()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, storageCentersForCompany, accountingCreditEntriesForCompany, loadStorageCentersForCompany, userLoggedIn, contactsForCompany, productsForCompany, productVariantsForCompany, servicesForCompany, treasuryAccountsForCompany, loadContactsForCompany, settingsForCompany, loadSettingsForCompany, loadProductproductVariantsForCompany}}></Outlet>
  );
}

export function UseOutletContextPos() {
  return useOutletContext<ContexType>()
};

export default PosPage;
